import { AuthForm } from "routes/auth/components/AuthForm";

export const ForgotPassword = () => {
  return <AuthForm mode="forgot-password" />;
};
